/**
 * Outline drag reordering should only preview once the pointer crosses the
 * midpoint of the hovered row. This keeps optimistic reordering stable while a
 * dragged item moves through a dense outline list.
 */
export function resolveOutlineHoverReorderIndex(data: {
    interactionDisabled: boolean,
    draggedId: string,
    hoveredId: string,
    draggedIndex: number,
    hoveredIndex: number,
    isShallowOver: boolean,
    isSameContainer: boolean,
    hoverTop?: number,
    hoverBottom?: number,
    clientOffsetY?: number,
}): number | null {
    if (
        data.interactionDisabled
        || !data.isSameContainer
        || data.draggedId === data.hoveredId
        || data.draggedIndex === data.hoveredIndex
        || !data.isShallowOver
        || data.hoverTop == null
        || data.hoverBottom == null
        || data.clientOffsetY == null
    ) {
        return null;
    }

    const hoverMiddleY = (data.hoverBottom - data.hoverTop) / 2;
    const hoverClientY = data.clientOffsetY - data.hoverTop;

    if (data.draggedIndex < data.hoveredIndex && hoverClientY < hoverMiddleY) {
        return null;
    }

    if (data.draggedIndex > data.hoveredIndex && hoverClientY > hoverMiddleY) {
        return null;
    }

    return data.hoveredIndex;
}
